import React, {useMemo} from 'react';
import {SubTaskCreationSingleVoyage} from "@containers/singleVoyage/tasks/types";
import {SetStatePropsType} from "@baseTypes/base";
import ItemSubtaskSingleVoyage from "@containers/singleVoyage/tasks/mutateTask/subtasks/item/ItemSubtaskSingleVoyage";
import Stack from '@mui/material/Stack';
import DividerCustom from "@ui/dividerCustom/DividerCustom";
import {PlusIcon} from "@ui/icons/icons";
import {useTranslation} from 'react-i18next';
import {sx} from './sx'
import SecondaryButtonSingleVoyage
	from "@containers/singleVoyage/ui/buttonts/secondaryButtonSingleVoyage/SecondaryButtonSingleVoyage";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {ErrorMessage} from "@hooks/validate/types";
import {TaskWayPointSingleVoyage} from "@containers/singleVoyage/tasks/table/types";

interface IProps {
	subtasks: SubTaskCreationSingleVoyage[],
	setSubtasks: SetStatePropsType<SubTaskCreationSingleVoyage[]>,
	waypoints: TaskWayPointSingleVoyage[]
	error?: boolean,
	errorMessage?: ErrorMessage,
	parentWaypointIds: string[]
	accountId: string | number
}

const SubtasksSingleVoyage = ({
								  setSubtasks,
								  subtasks,
								  waypoints,
								  error,
								  errorMessage,
								  parentWaypointIds,
								  accountId
							  }: IProps) => {
	
	const {t} = useTranslation()
	
	const waypointsFiltered = useMemo(() => {
		if (!parentWaypointIds?.length) {
			return []
		}
		return waypoints.filter((item) => parentWaypointIds.includes(item.id?.toString()))
	}, [waypoints, parentWaypointIds])
	
	const list = subtasks?.length >= 1 && subtasks.map((subtask, index) => {
		return (
			<ItemSubtaskSingleVoyage
				subtask={subtask}
				key={index}
				setSubtasks={setSubtasks}
				index={index}
				waypoints={waypointsFiltered}
				error={error}
				errorMessage={errorMessage}
				accountId={accountId}
			/>
		)
	})
	
	const onAdd = () => {
		setSubtasks((prev) => {
			return [
				...prev,
				{
					title: '',
					description: '',
					waypointIds: parentWaypointIds?.length >= 1 ? [Number(parentWaypointIds[parentWaypointIds.length - 1])] : [],
					planCompletionTime: null,
					status: 'PLANNED',
					taskConfigTemplateId: 0,
					type: 'REGULAR_SUBTASK',
				}
			]
		})
	}
	
	return (
		<Stack
			gap={1}
			sx={sx.root}
			alignItems={'flex-start'}
		
		>
			<DividerCustom
				sx={sx.divider}
				label={t('singleVoyage.subtasks')}
				icon={<FormatListBulletedIcon/>}
			/>
			
			<SecondaryButtonSingleVoyage
				startIcon={<PlusIcon/>}
				onClick={onAdd}
				sx={sx.btn}
			>
				{t('singleVoyage.addSubtask')}
			</SecondaryButtonSingleVoyage>
			
			<Stack
				gap={1}
				sx={sx.list}
			>
				{list}
			</Stack>
		</Stack>
	);
};

export default SubtasksSingleVoyage;
